import { useMap } from "@vis.gl/react-google-maps";
import { useEffect, useState } from "react";
import MapApiRepository from "../repositories/MapApiRepository";
import MapService, { IMapService } from "../services/MapService";
import MapPropertiesService from "../services/MapPropertiesService";
import { MapPolygon } from "./MapPolygon";


interface MapEvaluationProps {
    evaluation: any
}

export const MapEvaluation = ({
    evaluation
}: MapEvaluationProps) => {

    const map = useMap();
    const mapService: IMapService = new MapService();
    const mapProperties = MapPropertiesService.properties;

    const [features, setFeatures] = useState<any[]>([]);

    useEffect(() => {

        if (!map) return;

        const initialize = async () => {
            const response = await MapApiRepository.getEvaluationFairwayAreasAsync(evaluation);
            if (response.ok) {
                const data = await response.json();
                const features: any[] = [];
                const bounds = new window.google.maps.LatLngBounds();

                for (const feature of data.fairwayAreaGeoJson.features) {
                    mapService.setFairwayAreaGeometryAndBounds(feature);

                    feature.properties = {
                        featureType: mapProperties.EvaluationFeatureType
                    };

                    const coordinates = mapService.getCoordinatesFromGeometry(feature.geometry);
                    mapService.extendBounds(bounds, coordinates);

                    features.push(feature);
                }
                setFeatures(features);

                map!.setCenter(bounds.getCenter());
                map!.fitBounds(bounds);
            }
        }
        initialize();
    }, [map]);

    return (
        features.map((feature: any, index: number) =>
            <MapPolygon
                ref={null}
                key={index}
                source={feature}
            />
        )
    )
}
